import { render } from "./TrendWidget.vue?vue&type=template&id=07b71342&scoped=true"
import script from "./TrendWidget.vue?vue&type=script&lang=js"
export * from "./TrendWidget.vue?vue&type=script&lang=js"

import "./TrendWidget.vue?vue&type=style&index=0&id=07b71342&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07b71342"]])

export default __exports__